<template>
    <div class="all">
        <!-- 區塊一 -->
        <section id="section1" class="section1">
            <div class="about-banner desktop">
                <h1>About us<br>關於我們</h1>
            </div>
            <div class="content desktop">
                <div class="custom-container">
                    <h3 class="header" data-aos="fade-up" data-aos-duration="800">我們討厭一成不變的模板<br>或是被複製的行銷模式</h3>
                    <div class="text-wrap d-flex">
                        <div class="text-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay="300">
                            有感於市面眾多的網頁設計為因應快速商業而生，導致許多套板型/模板型網站建置快速但卻卻往往不符企業形象，難以為客戶帶來良好的品牌效益。
                        </div>
                        <div class="text-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay="600">
                            無極限不滿於單純的複製模板，我們將網頁設計有意識的重組『視覺、創意、技術、行銷』使每個環節緊緊相依。無極限認為一個成功的網頁設計，如果沒有為使用者解決需求，只在於視覺華麗或功能強大，那麼也枉費一個設計。
                        </div>
                        <div class="text-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay="900">
                            不斷追求進步的我們，無論在較新的網站架設SPA技術、RWD響應式網頁及登陸頁大於首頁優先的年代，我們都極其重視每一個細部環節，持續打造人性為主科技為輔的好網站，都象徵不斷追求進步的態度。
                        </div>
                    </div>
                </div>
            </div>
            <div class="content mobile">
                <h1 data-aos="fade-up" data-aos-duration="800">我們討厭一成不變的模板<br>或是被複製的行銷模式</h1>
                <p data-aos="fade-up" data-aos-duration="800">有感於市面眾多的網頁設計為因應快速商業而生，導致許多套板型/模板型網站建置快速但卻卻往往不符企業形象，難以為客戶帶來良好的品牌效益。</p>
                <p data-aos="fade-up" data-aos-duration="800">無極限不滿於單純的複製模板，我們將網頁設計有意識的重組『視覺、創意、技術、行銷』使每個環節緊緊相依。無極限認為一個成功的網頁設計，如果沒有為使用者解決需求，只在於視覺華麗或功能強大，那麼也枉費一個設計。</p>
                <p data-aos="fade-up" data-aos-duration="800">不斷追求進步的我們，無論在較新的網站架設SPA技術、RWD響應式網頁及登陸頁大於首頁優先的年代，我們都極其重視每一個細部環節，持續打造人性為主科技為輔的好網站，都象徵不斷追求進步的態度。</p>
            </div>
        </section>
        <!-- 區塊二 -->
        <section class="section2">
            <div class="custom-container">
                <div class="s2-content">
                    <h3 class="title">
                        <div class="nothing" data-aos="zoom-out" data-aos-duration="1500"></div>
                        <div data-aos="fade-right" data-aos-duration="800" data-aos-delay="300">「無限的被動商機」</div>
                    </h3>
                    <p class="text" data-aos="fade-up" data-aos-duration="800" data-aos-delay="600">
                        我們想的不是如何從您的口袋賺錢，而是如何
                        讓您賺更多錢！一個成功的網頁設計，不只在
                        於視覺華麗或功能強大，如果沒有為您創造商
                        機並帶進收入，那麼也枉費一個設計。
                    </p>
                    <p class="text" data-aos="fade-up" data-aos-duration="800" data-aos-delay="600">
                        網站是您與客戶間在網頁世界裡的第一印象，
                        透過網頁清楚傳達給客戶您的服務內<br>容是甚麼？為什麼您的商品與別人不同？這是
                        網站最基本的功用，接下來，如何透過網站來
                        提升企業品牌形象、創造商機、提高營收，這
                        才是網頁設計的最終目標。
                    </p>
                    <p class="text" data-aos="fade-up" data-aos-duration="800" data-aos-delay="600">
                        無極限將心力放在與客戶間緊密的溝通及結案
                        後為客戶提供的教育訓練。讓客戶更<br>能了解如何利用網站創造更高的商機，並了解
                        網頁設計的價值所在。
                    </p>
                </div>
            </div>
        </section>
        <!-- 區塊三 -->
        <section class="section3">
            <div class="custom-container">
                <div class="service-mode">
                    <h2 class="title" data-aos="fade-up" data-aos-duration="800">「從心出發」的服務模式</h2>
                    <div class="text" data-aos="fade-up" data-aos-duration="800">
                        因為我們知道，客戶通常在決定建置網站時，可能<br>
                        仍然對網站一無所知。因此，無極限完全站在客戶立場，從與您一起合作選取素材、版型、<br>
                        內容規劃建議、主視覺定調並提供免費授權圖片，甚至還能每月享有限量網頁維護的權益。<br>
                        無極限將心比心的服務精神，讓您在架設網站有強大的依靠。
                    </div>
                </div>
            </div>
            <div class="six-advantage">
                <h2 class="title" data-aos="fade-up" data-aos-duration="800">無極限 6 大優勢</h2>
                <div class="advantage-wrap d-flex flex-wrap">
                    <div class="advantage-item design" data-aos="flip-right" data-aos-duration="1500">
                        <div class="mask d-flex justify-content-center align-items-center">
                            <div class="mask-text">
                                <h3>設計工藝</h3>
                                <p class="desktop">煥然一新<br>喚起全新的企業網站</p>
                                <p class="mobile">煥然一新<br>喚起全新的企業網站</p>
                            </div>
                        </div>
                    </div>
                    <div class="advantage-item backend" data-aos="flip-right" data-aos-duration="1500">
                        <div class="mask d-flex justify-content-center align-items-center">
                            <div class="mask-text">
                                <h3>完整後台</h3>
                                <p class="desktop">人性化的操作介面<br>簡易上手，輕鬆操作後台介面</p>
                                <p class="mobile">人性化的操作介面簡易上手，輕鬆操作後台介面</p>
                            </div>
                        </div>
                    </div>
                    <div class="advantage-item group" data-aos="flip-right" data-aos-duration="1500">
                        <div class="mask d-flex justify-content-center align-items-center">
                            <div class="mask-text">
                                <h3>專業團隊</h3>
                                <p class="desktop">專業分工<br>每個細節皆展現出最專業的一面</p>
                                <p class="mobile">專業分工<br>每個細節皆展現出最專業的一面</p>
                            </div>
                        </div>
                    </div>
                    <div class="advantage-item image" data-aos="flip-right" data-aos-duration="1500">
                        <div class="mask d-flex justify-content-center align-items-center">
                            <div class="mask-text">
                                <h3>授權圖庫</h3>
                                <p class="desktop">高解析度的商業使用圖庫<br>為您大大提升整體網站質感</p>
                                <p class="mobile">高解析度的商業使用圖庫</p>
                            </div>
                        </div>
                    </div>
                    <div class="advantage-item function" data-aos="flip-right" data-aos-duration="1500">
                        <div class="mask d-flex justify-content-center align-items-center">
                            <div class="mask-text">
                                <h3>功能齊全</h3>
                                <p class="desktop">高度彈性的模組化功能設計<br>滿足挑剔時尚的眼光</p>
                                <p class="mobile">高度彈性的模組化功能設計</p>
                            </div>
                        </div>
                    </div>
                    <div class="advantage-item social" data-aos="flip-right" data-aos-duration="1500">
                        <div class="mask d-flex justify-content-center align-items-center">
                            <div class="mask-text">
                                <h3>行銷工具</h3>
                                <p class="desktop">持續開發專業的行銷系統<br>讓您在行銷上更能盡情發揮</p>
                                <p class="mobile">持續開發專業的行銷系統</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-container">
                <div class="program-process">
                    <h2 class="title" data-aos="fade-up" data-aos-duration="800">專案流程</h2>
                    <div class="process-wrap d-flex">
                        <div class="process-item" data-aos="zoom-in" data-aos-duration="1000">
                            <h3>了解需求</h3>
                            <img src="/static/images/about/icon_need.svg" alt="">
                            <ul>
                                <li>專案報價</li>
                                <li>合同簽立</li>
                                <li>網域命名/申請</li>
                            </ul>
                        </div>
                        <div class="process-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="100">
                            <h3>形象規劃確立</h3>
                            <img src="/static/images/about/icon_content.svg" alt="">
                            <ul>
                                <li>客戶資料提供</li>
                            </ul>
                        </div>
                        <div class="process-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="200">
                            <h3>網頁設計</h3>
                            <img src="/static/images/about/icon_web_design.svg" alt="">
                            <ul>
                                <li>設計校對</li>
                                <li>網站內容確認</li>
                            </ul>
                        </div>
                        <div class="process-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300">
                            <h3>程式撰寫</h3>
                            <img src="/static/images/about/icon_backend.svg" alt="">
                            <ul>
                                <li>網頁整體核對</li>
                            </ul>
                        </div>
                        <div class="process-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="400">
                            <h3>項目定案完結</h3>
                            <img src="/static/images/about/icon_projectend.svg" alt="">
                            <ul>
                                <li>客戶審核簽字</li>
                                <li>尾款支付</li>
                            </ul>
                        </div>
                        <div class="process-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="500">
                            <h3>網站上架</h3>
                            <img src="/static/images/about/icon_online.svg" alt="">
                            <ul>
                                <li>後續服務</li>
                                <li>年度空間續約</li>
                                <li>網址續約</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 區塊四 -->
        <section class="section4">
            <div class="custom-container">
                <h4>專案流程</h4>
                <div class="postition-wrap d-flex">
                    <div class="position-item" data-aos="zoom-in" data-aos-duration="1000">
                        <img src="/static/images/about/icon_ProjectPlaner.svg" alt="">
                        <h3 class="job-title">專案規劃師</h3>
                        <ul>
                            <li>網站功能</li>
                            <li>產品定位</li>
                            <li>關鍵字置入</li>
                            <li>資料庫應用</li>
                        </ul>
                    </div>
                    <div class="position-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="100">
                        <img src="/static/images/about/icon_webDesign.svg" alt="">
                        <h3 class="job-title">網頁設計</h3>
                        <ul>
                            <li>感覺統合</li>
                            <li>版型設計</li>
                            <li>輔助圖形設計</li>
                        </ul>
                    </div>
                    <div class="position-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="200">
                        <img src="/static/images/about/icon_MarketPlaner.svg" alt="">
                        <h3 class="job-title">網路行銷</h3>
                        <ul>
                            <li>專案規劃師</li>
                            <li>SEO關鍵字分析</li>
                            <li>社群網站規劃</li>
                        </ul>
                    </div>
                    <div class="position-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300">
                        <img src="/static/images/about/icon_Programer.svg" alt="">
                        <h3 class="job-title">程式開發師</h3>
                        <ul>
                            <li>資料庫置入</li>
                            <li>測試執行</li>
                            <li>網站運作維護</li>
                            <li>資料安全維護</li>
                        </ul>
                    </div>
                    <div class="position-item" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="400">
                        <img src="/static/images/about/icon_CEO.svg" alt="">
                        <h3 class="job-title">總策劃師</h3>
                        <ul>
                            <li>網路行銷</li>
                            <li>流量檢測</li>
                            <li>成果分析</li>
                            <li>規劃調整</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import navigation from './navigation.vue';
    export default {
      name: 'About',
      components:{
            navigation
      },
      data() {
        return {

        }
      }
    }
</script>

<style lang="scss" scoped>
    @import 'src/assets/scss/about/section1.scss';
    @import 'src/assets/scss/about/section2.scss';
    @import 'src/assets/scss/about/section3.scss';
    @import 'src/assets/scss/about/section4.scss';

    nav::after {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/About.vue